import backButton from './listeners/backButton'
import keyboard from "@/ts/mobile/listeners/keyboard";

const addListeners = () => {
     backButton()
     keyboard()
}

export default addListeners;
